var path = 'src/app/patients/cohorts/cohort.html';
var html = "<h1 class=page-header>{{cohort.name}}</h1> <div ng-if=cohort.instructions ng-bind-html=\"cohort.instructions | unsafe\"></div> <p ng-if=!cohort.instructions><i>No instructions available.</i></p> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/cohorts/cohort.html
 ** module id = 396
 ** module chunks = 0
 **/